var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('daq-cropper',{attrs:{"width":"100%","height":"100%","url":"https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1542282599730&di=843a71042e50036df359b1050f8af775&imgtype=0&src=http%3A%2F%2Fpic29.nipic.com%2F20130527%2F8786105_130215865000_2.jpg"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3aab7118","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/page/cropper.vue
// module id = null
// module chunks = 